/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Sync_Pick_CategoryInputs */

const vi_expense_sync_pick_category = /** @type {(inputs: Expense_Sync_Pick_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn danh mục`)
};

/**

* @param {Expense_Sync_Pick_CategoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_sync_pick_category = /** @type {((inputs?: Expense_Sync_Pick_CategoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Sync_Pick_CategoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_sync_pick_category(inputs)
});